module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/produto-pacote/produto-pacote.component.css
// module id = ./src/app/produto-pacote/produto-pacote.component.css
// module chunks = main